<template>
  <div class="game-chat">
    <v-alert
      :value="showAlert"
      :type="isSuccess ? 'success' : 'error'"
      transition="scale-transition"
      class="game-chat__alert"
    >
      {{ alertText }}
    </v-alert>

    <message-modal
      v-show="showModal"
      :selectedItem="selectedItem"
      :modalTitle="modalTitle"
      :action="action"
      :showModal="showModal"
      @close="showModal = false"
    />

    <div style="display: flex; justify-content: space-between">
      <v-text-field
        v-model="search"
        class="game-chat__search"
        append-icon="search"
        label="Поиск"
        color="accent"
        single-line
        hide-details
      />

      <div class="game-chat__message">
        <v-textarea
          v-model="newMessage"
          box
          name="input-7-4"
          label="Текст сообщения"
          color="accent"
          :error-messages="errorMessage"
          auto-grow
          rows="1"
          @keyup="handleKeyUp"
        >
          <template #append>
            <v-icon id="Emoji" style="padding: 0 10px" @click="toogleDialogEmoji">sentiment_very_satisfied</v-icon>
          </template>
        </v-textarea>

        <v-btn style="margin-top: 10px;" flat @click="sendMessageCatcher">
          <v-icon>send</v-icon>
        </v-btn>

        <div v-show="!dialogHidden" ref="emojiPicker" class="message-emoji">
          <VEmojiPicker :pack="emojisNative" labelSearch="Search" @select="onSelectEmoji" />
        </div>
      </div>
    </div>

    <paginated-table
      :items="gameChat"
      :pullFunction="getChat"
      :headers="headers"
      :pagination.sync="pagination"
      :search="search"
      :loading="loading"
    >
      <template #items="props">
        <td v-for="(header, i) in headers" :key="i">{{ props.item[header.value] }}</td>
      </template>
      <template #items="props">
        <td>{{ props.item.date }}</td>
        <td>{{ props.item.time }}</td>
        <td>
          <v-btn
            text
            small
            flat
            :to="{ name: 'user', params: { user: props.item.message.user_id } }"
            style="text-transform: none; padding: 0; min-width: auto;display: inline-flex"
          >
            {{ props.item.message.user_name }}
          </v-btn>
        </td>
        <td class="game-chat__text-body">{{ props.item.message.body }}</td>
        <td>
          <v-btn
            fab
            small
            color="secondary"
            style="display: inline"
          >
            <v-icon
              small
              @click="editItem(props.item)"
            >
              edit
            </v-icon>
          </v-btn>
          <v-btn
            fab
            small
            color="secondary"
            style="display: inline"
          >
            <v-icon
              small
              @click="deleteItem(props.item)"
            >
              delete
            </v-icon>
          </v-btn>
          <v-btn
            fab
            small
            color="secondary"
            style="display: inline"
          >
            <v-icon
              small
              @click="blockItem(props.item)"
            >
              speaker_notes_off
            </v-icon>
          </v-btn>
        </td>
      </template>
    </paginated-table>
    <Base--SideButtons class="game-chat__buttons" back />
  </div>
</template>

<script>
import axios from 'axios'
import VEmojiPicker from 'v-emoji-picker'
import packEmoji from 'v-emoji-picker/data/emojis.js'
import { baseURL } from '../api/config'
import MessageModal from '../components/modals/MessageModal.vue'
import VueMixin from '../components/VueMixin'
import PaginatedTable from '@/components/PaginatedTable.vue'

export default {
  components: {
    PaginatedTable,
    MessageModal,
    VEmojiPicker
  },
  mixins: [VueMixin],
  data: () => ({
    gameChat: [],
    search: '',
    message: '',
    loading: true,
    showModal: false,
    modalTitle: '',
    selectedItem: null,
    indexItem: 0,
    action: '',
    alertText: '',
    isSuccess: false,
    showAlert: false,
    blockTime: 0,
    newMessage: '',
    errorMessage: '',
    dialogHidden: true,
    pagination: {
      sortBy: 'message.created_at',
      descending: true
    },
    headers: [
      { text: 'Дата', value: 'date' },
      { text: 'Время', value: 'message.created_at' },
      { text: 'Логин', value: 'message.user_name' },
      { text: 'Текст сообщения', value: 'message.body' },
      { text: 'Действия', sortable: false }]
  }),
  computed: {
    emojisNative () {
      return packEmoji
    }
  },
  watch: {
    pagination () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    message () {
      switch (this.message.what_happened) {
        case 'create': {
          this.gameChat.push({
            date: this.formDate(new Date()),
            message: {
              body: decodeURIComponent(this.message.body),
              created_at: new Date(),
              chat_id: 1,
              id: this.message.id,
              user_id: this.message.sender_id,
              user_avatar: this.message.avatar_sender,
              user_name: this.message.name_sender
            },
            time: this.formTime(new Date())
          })
          break
        }
        case 'update': {
          this.gameChat.forEach(item => {
            if (parseInt(item.message.id) === this.message.id)
              item.message.body = this.message.body

          })
          break
        }
        case 'delete': {
          this.gameChat.forEach((item, i) => {
            if (parseInt(item.message.id) === this.message.id)
              this.gameChat.splice(i, 1)

          })
          break
        }
      }
    },
    newMessage (n) {
      const text = n
        .trim()
        .replace(/\n+/g, '\n')
        .trim()

      if (text)
        this.errorMessage = ''
    }
  },
  mounted () {
    this.getChat(1)
    const chatName = 'chats.game.catcher'
    this.subscribeChat(chatName)
    EventBus.$on('message-emit', data => {
      this.alertText = data
      this.showAlert = true
      this.animateAlert()
    })
  },
  beforeDestroy () {
    EventBus.$off('message-emit')
  },
  methods: {
    close () {
      this.showModal = false
      this.selectedItem = null
    },
    handleKeyUp (event) {
      if (event.key === 'Enter' && !event.shiftKey)
        this.sendMessageCatcher()
    },
    sendMessageCatcher () {
      this.newMessage = this.newMessage
        .trim()
        .replace(/\n+/g, '\n')
        .trim()

      if (!this.newMessage) {
        this.errorMessage = 'Поле не должно быть пустым'
        return
      }

      const url = `${baseURL}/catcher-game/chat/messages`
      axios
        .post(url, {
          body: this.newMessage
        })
        .then(response => {
          this.newMessage = ''
          this.alertText = 'Сообщение успешно добавлено в чат!'
          this.isSuccess = true
          this.animateAlert()
        })
        .catch(error => {
          this.alertText = error.response.data.message
          this.isSuccess = false
          this.animateAlert()
          console.error(error)
        })
    },
    getChat (page) {
      const offset = (page - 1) * 25
      const url = `${baseURL}/catcher-game/chat/messages?limit=${26}&offset=${offset}&sort=created_at:desc`
      axios
        .get(url)
        .then(({ data }) => {
          this.gameChat = data.map(message => ({
            date: this.formDate(message.created_at), time: this.formTime(message.created_at), message
          }))
          this.loading = false
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss">
.game-chat, .support-chat {
    #EmojiPicker {
        position: absolute;
        left: 51.5%;
        z-index: 100;
        top: 60%;
    }
    .grid-emojis {
        .emoji {
            font-size: 20px;
            padding: 0px;
        }
    }
    textarea {
        max-height: 350px
    }
    .game-chat__search {
      width: 40%;
      flex: none;
      .theme--light.v-label {
            left: 20px !important;
        }
    }
    &__message {
      display: flex;
      width: 45%;
      position: relative;
    }
    &__alert {
        position: fixed;
        margin-top: -10px;
        width: auto;
        border-radius: 5px;
        margin-left: auto;
        right: 30px;
        z-index: 300;
    }
    &__text-body {
        max-width: 600px;
      overflow: hidden;
    }
    .theme--light.v-btn {
        display: block;
    }
    &__buttons {
        .v-btn {
            &:last-of-type {
                display: none;
            }
        }
    }
}
    .modal-chat {
        &__title {
            box-shadow: rgba(0,0,0,0.5) 0 0 8px 0px;
            font-size: 20px;
        }
        &__confirm {
            font-size: 18px;
        }
    }
    .user_link.theme--light.v-btn {
        box-shadow: none !important;
        width: fit-content;
        background: none !important;
        line-height: 30px;
        text-transform: none;
        display: block;
        margin: 0px;
        padding: 0px;
        .v-btn__content {
            margin: 0;
        }
    }
    .v-btn--floating.v-btn--small .v-icon {
       font-size: 29px;
    }
    .layout {
        margin-bottom: 25px;
    }
</style>
